export default __webpack_public_path__ + "static/media/y_wdt_c_2.6d7930bc.mp3";